import { ModelMixin } from '@models/core/base-generic.model';

export class JurisdictionToggle extends ModelMixin<JurisdictionToggle>() {
    protected static _resource = 'jurisdiction_toggles';

    get jurisdiction(): string {
        return this._attributes['jurisdiction'];
    }

    get periodic(): boolean {
        return this._attributes['periodic'];
    }

    get taxable(): boolean {
        return this._attributes['taxable'];
    }

    get pensionable(): boolean {
        return this._attributes['pensionable'];
    }

    get insurable(): boolean {
        return this._attributes['insurable'];
    }

    get vacationable(): boolean {
        return this._attributes['vacationable'];
    }

    get eptable(): boolean {
        return this._attributes['eptable'];
    }

    get lumpSummable(): boolean {
        return this._attributes['lumpSummable'];
    }
}
